module.exports = __webpack_public_path__ + "static/img/empty.e481eebf.svg";